<template>
    <DashboardHeader />
    <div class="section overflow-hidden position-relative" id="wrapper">
        <DashboardSidebar @sidebar-toggle="handleSidebarToggle" />
        <div class="main-content" :style="{ marginLeft: contentMargin }">
            <router-view />
        </div>
    </div>
    <DashboardFooter />
</template>

<script>
import DashboardHeader from "@/components/Dashboard/DashboardHeader.vue";
import DashboardFooter from "./../DashboardFooter.vue";
import DashboardSidebar from "./DashboardSidebar.vue";

export default {
    name: "UserDashboardLayout",
    components: {
        DashboardHeader,
        DashboardFooter,
        DashboardSidebar,
    },
    data() {
        return {
            sidebarExpanded: false
        };
    },
    computed: {
        contentMargin() {
            return this.sidebarExpanded ? '220px' : '100px';
        }
    },
    methods: {
        handleSidebarToggle(isExpanded) {
            this.sidebarExpanded = isExpanded;
        }
    }
};
</script>

<style scoped>
.main-content {
    transition: margin-left 0.3s ease;
    min-height: calc(100vh - 80px);
}

@media (max-width: 768px) {
    .main-content {
        margin-left: 80px !important;
    }
}
</style>